import { Box, Typography } from '@mui/material';
import { styled as muStyled } from '@mui/material/styles';
import { useAppKitWallet, Wallet as WalletType } from '@reown/appkit-wallet-button/react';
import { LocalStorageKey, Wallet } from '@shared/constants';
import { setWalletReloadInfoModalSecondsLate } from '@entities/user/model';
import { FC } from 'react';
import { styled } from '@shared/styles';

const Img = muStyled('img')(({ theme }) => ({
  margin: theme.spacing(0.5)
}));

interface WalletLogoProps {
  title: string;
  wallet: Wallet | 'browser';
  connector: WalletType;
  className?: string;
  onClick: (wallet: WalletType) => void | Promise<void>;
  ext?: string;
}

let WalletLogo: FC<WalletLogoProps> = ({ onClick, title, wallet, connector, className, ext }) => {
  // const { connect } = useAppKitWallet();

  const handleClick = () => {
    // connect(connector);
    console.log('CONNECTOR IS', connector);
    onClick(connector);
    localStorage.setItem(LocalStorageKey.connectedWalletType, connector);

    // if (connector === 'metamask') {
    //   setWalletReloadInfoModalSecondsLate(0);
    // } else {
    //   setWalletReloadInfoModalSecondsLate(null);
    // }
  };

  return (
    <Box className={`${className}${connector === 'metamask' ? ' metamask-connector' : ''}`} onClick={handleClick}>
      <Img loading='lazy' height='60' alt={title} src={`/images/icons/wallets/${wallet}.${ext || 'svg'}`} />
      <Typography className='title'>{title}</Typography>
    </Box>
  );
};

WalletLogo = styled(WalletLogo, {
  '&': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    mx: 2,
    // mb: 2,
    minWidth: 80,
    maxWidth: 80,
    cursor: 'pointer'
  },
  '& .title': {
    fontSize: 10,
    textAlign: 'center',
    color: 'white',

    '@media(max-width: 520px)': {
      whiteSpace: 'pre-wrap'
    }
  }
});

export { WalletLogo };
